import { Linkedin, Facebook,MessageSquare} from 'lucide-react';
import { SOCIAL_LINKS, HASHTAGS } from '../data/content';
import { CONTACT_INFO } from '../data/content';

const IconMap = {
  Linkedin: <Linkedin size={20} />,
  Facebook: <Facebook size={20} />,
  MessageSquare: <MessageSquare size={20} />
};

export const Footer = () => {

    const handleTicketClick = (e) => {
    const ticketId = Math.floor(1000 + Math.random() * 9000);
    const subject = encodeURIComponent(`Support Inquiry - Ticket #${ticketId}`);
      
    // Update the link href dynamically upon click
    e.currentTarget.href = `mailto:${CONTACT_INFO.email}?subject=${subject}`;
    }

  return(
  <footer className="bg-[#0A192F] border-t border-slate-800 pt-16 pb-8 px-6">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
        
        {/* Brand & Status */}
        <div className="flex flex-col items-center md:items-start">
          <div className="text-xl font-black text-white mb-4 tracking-tighter">
            Infra<span className="text-blue-500">Tier</span>
          </div>
          <div className="flex items-center gap-2 px-3 py-1 bg-green-500/10 border border-green-500/20 rounded-full">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            <span className="text-[10px] font-bold text-green-500 uppercase tracking-widest">Systems Operational</span>
          </div>
        </div>

        {/* Social & Hashtags */}
        <div className="flex flex-col items-center">
          <div className="flex gap-5 mb-6">
          {SOCIAL_LINKS.map((social) => (
            <a 
              key={social.name} 
              href={social.href} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-blue-400 p-2 bg-slate-800/30 rounded-lg border border-slate-800 transition-all"
              aria-label={social.name}
            >
              {IconMap[social.icon]}
            </a>
          ))}
          </div>
          <div className="flex flex-wrap justify-center gap-2">
            {HASHTAGS.slice(0, 4).map(tag => (
              <span key={tag} className="text-[10px] font-mono text-slate-600">{tag}</span>
            ))}
          </div>
        </div>

        {/* Quick Contact */}
        <div className="flex flex-col items-center md:items-end">
          <p className="text-sm text-slate-400 mb-2 font-medium">Have a critical issue?</p>
          <a 
          href={`mailto:${CONTACT_INFO.email}`}
          onClick={handleTicketClick} 
          className="text-white hover:text-blue-400 font-bold transition">
            support@infra-tier.com
          </a>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="pt-8 border-t border-slate-900 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-xs text-slate-600">© 2026 InfraTier. All rights reserved.</p>
        <div className="flex gap-6 text-xs text-slate-600">
          <a href="#" className="hover:text-slate-400">Privacy Policy</a>
          <a href="#" className="hover:text-slate-400">Terms of Service</a>
        </div>
      </div>
    </div>
  </footer>
 );
};